export function useVariable(init) {
    let val = init;
    return {
        get: () => val,
        set: (v) => {
            val = v;
        },
    };
}
